import { useRouter } from 'next/router';

// Utils
import { useAccessControl } from '@/utils/hooks/middleware/useAccessControl';

//Components
import LoaderPage from '@/components/base/Loader/LoaderPage';

type AccessControlProps = { children: React.ReactNode };

export function AccessControl({ children }: AccessControlProps) {
    const router = useRouter();
    const { hasAccess, redirect_url } = useAccessControl();

    if (!hasAccess) {
        router.push(redirect_url);
        return <LoaderPage />;
    }

    return children;
}
